export const VIEW_TYPES = {
  KANBAN: "kanban",
  LIST: "list",
} as const;

export const VIEW_TYPES_MAP = {
  [VIEW_TYPES.KANBAN]: "Kanban",
  [VIEW_TYPES.LIST]: "Lists",
} as const;
